export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
  
  },
  h2: {
    fontWeight: 500,
    fontSize: 30,
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
  },
  overline: {
    fontWeight: 500,
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
  },
};
